import React from 'react'
import { Link } from 'react-router-dom'

export default (
    <>
        <div>
            <h1>Terms and conditions</h1>
        </div>
        <div>
            <p>
                <em>Effective Date: March 2020</em>
            </p>
            <p>
                These terms and conditions (the “Terms and Conditions”) govern and apply to anyone accessing or using
                the IKEA North America Services, LLC website located at www.ikea.com/ms/en_US, and any associated
                websites, mobile sites or applications, products, software and other services (collectively, the
                “Services”). These Terms and Conditions apply to any use of the Services.
            </p>
            <p>
                The Services are owned and operated by IKEA North America Services and its parents, affiliates, and/or
                franchisors (collectively, “IKEA,” “we,” “our,” or “us”). While using the Services, please be aware that
                your access to and use of the Services and any information or documents offered by IKEA (“Materials”)
                are subject to these Terms and Conditions. If you choose to continue to use or access the Services after
                having the opportunity to read these Terms and Conditions, you are indicating your acceptance of the
                Terms and Conditions and <Link to="/privacypolicy">IKEA’s Privacy Policy</Link>. If you do not agree
                with any part of these Terms and Conditions or IKEA’s Privacy Policy, please do not use the Services.
            </p>
            <p>
                IKEA reserves the right to modify these Terms and Conditions at any time without notice, and such
                changes shall be deemed effective immediately upon posting of the modified Terms and Conditions. You
                should regularly review these Terms and Conditions to ensure that you are aware of, understand and
                accept any changes made. Your continued use of the Services following the posting of changes to these
                Terms and Conditions will indicate your acceptance those changes.{' '}
            </p>
            <p>
                THE SERVICES ARE NOT INTENDED FOR USE OR ACCESS BY ANYONE UNDER THE AGE OF 18. IF YOU ARE UNDER THE AGE
                OF 18, YOU MAY NOT USE OR ACCESS THE WEBSITE OR PROVIDE US WITH ANY PERSONALLY IDENTIFIABLE INFORMATION.
                You may not use the Services and may not accept these Terms and Conditions if (1) you are not of legal
                age to form a binding contract with IKEA, or (2) you are a person barred from receiving the Services
                under the laws of the jurisdiction in which you are resident or from which you use the Services.
            </p>
        </div>
        <div>
            <p>
                <strong>1. Account Creation and Information</strong>
            </p>
            <p>
                You may be required to establish an account prior to utilizing or obtaining certain Services or
                Materials. Available accounts include but are not limited to IKEA Family and IKEA Home Shopping
                accounts. If you choose to register for any IKEA account, you agree to: (a) provide true, accurate,
                current, and complete account registration information about yourself as prompted by the Services; and
                (b) maintain and promptly update such registration information to keep it true, accurate, current, and
                complete. If you provide any registration information that is untrue, inaccurate, not current, or
                incomplete, or if IKEA has a reasonable ground to suspect that such information is untrue, inaccurate,
                not current, or incomplete, IKEA has the right to suspend or terminate your account(s) and refuse any
                and all current or future use of the Services (or any portion thereof).
            </p>
            <p>
                You may choose to create a username, password and/or account designation (“Account Credentials”) in
                order to make purchases or otherwise use the Services. If you choose to create Account Credentials, you
                are responsible for maintaining the confidentiality of your Account Credentials, and are fully
                responsible for any and all interactions and activity when you, or any third, party access the Services
                using your Account Credentials. If you allow third parties to access the Services through use of your
                Account Credentials, you agree to defend and indemnify IKEA and its affiliates against any liability,
                costs, or damages, including attorney fees, arising out of claims or suits by such third parties based
                upon or relating to such access and use. You agree to (a) immediately notify IKEA of any unauthorized
                use of your Account Credentials or any other breach of security, and (b) ensure that you exit from your
                account(s) at the end of each session. IKEA cannot and will not be liable for any loss or damage arising
                from your failure to comply with this Section.
            </p>
        </div>
        <div>
            <p>
                <strong>2. Ownership and Copyright</strong>
            </p>
            <p>
                Copyrights, trademark rights, database rights, design rights and any and all other intellectual property
                and other rights relating to the Services and Materials existing now or in the future including but not
                limited to computer programs, source and object code, documentation, software graphics, text, images,
                designs, videos, sound, illustrations, animations, databases, logos, domain names, trade names and trade
                identities (collectively referred to as the “Content”), are the property of one or more IKEA entities.
                All elements of the Services, including without limitation the general design and the Content, are
                protected by trade dress, copyright, moral rights, trademark and other laws relating to intellectual
                property rights. The Services may only be used for the intended purpose for which they are being made
                available.
            </p>
            <p>
                Images of people or places displayed on the Services are either the property of, or used with permission
                by, IKEA. The use of these images by you, or anyone else authorized by you, is prohibited unless
                specifically permitted by these Terms and Conditions or specific permission provided elsewhere on the
                Services. Any unauthorized use of the images may violate copyright laws, trademark laws, the laws of
                privacy and publicity, and communications regulations and statutes.
            </p>
            <p>
                A single copy of the Materials may be downloaded or otherwise copied from the Services for
                non-commercial personal use only, provided however, that all copyright and other proprietary notices are
                kept intact. Any further copying, reproduction, publication, posting, transmission or distribution of
                any part of the Services in any way is prohibited. Except as provided herein, no license or right,
                express or implied, is granted to any person under any intellectual property right. Except as authorized
                under the copyright laws, you are responsible for obtaining permission before reusing any copyrighted
                material that is available through the Services. Modification of the Materials or use of the Materials
                for any other purpose is a violation of IKEA&apos;s copyright and other proprietary rights. IKEA neither
                warrants nor represents that your use of Materials will not infringe the rights of third parties not
                owned by or affiliated with IKEA.
            </p>
        </div>
        <div>
            <p>
                <strong>3. Use of Services</strong>
            </p>
            <p>
                The Services and Materials may not be copied, reproduced, republished, uploaded, posted, transmitted or
                distributed without the prior written permission of IKEA, except as provided herein. “Deep-linking,”
                “embedding” or using analogous technology is strictly prohibited. You are prohibited from posting to or
                transmitting from the Services any unlawful, threatening, libelous, defamatory, obscene, indecent,
                inflammatory, pornographic or profane material or any material that could constitute or encourage
                conduct that would be considered a criminal offense, give rise to civil liability, or otherwise violate
                any law. You are responsible for complying with all local rules, laws, and regulations including,
                without limitation, rules about intellectual property rights, the Internet, technology, data, electronic
                mail, publicity and privacy. You agree that you will not use any device, software or other
                instrumentality to interfere or attempt to interfere with the proper working of any of the Services, and
                that you will not take any action that imposes an unreasonable or disproportionately large load on our
                infrastructure. In addition, you may not use any robot, spider, other automatic device, or manual
                process to monitor, copy or scrape any of our web pages or the content contained herein, without the
                prior express written consent from an authorized executive of IKEA. You agree you will not interfere or
                attempt to interfere with or damage, impair or disable the operation of the Services, by any means,
                including but not limited to providing links to third party sites or uploading or otherwise
                disseminating viruses, worms, spyware, adware or other malicious code. You may also not reverse
                engineer, decompile, disassemble or otherwise attempt to discover the source code of the Services or any
                part thereof, except and only to the extent that such activity is expressly permitted by applicable law
                notwithstanding this limitation. You may not make any unsolicited offers, request, advertisements, or
                spam.{' '}
            </p>
            <p>
                You represent, warrant and agree that you will comply with the above acceptable use requirements. In
                addition to any remedies that we may have at law or in equity, if we determine, in our sole discretion,
                that you have violated or are likely to violate the foregoing prohibitions, we may take any action we
                deem necessary to cure or prevent the violation, including without limitation, the immediate removal of
                the related materials from the Services.
            </p>
        </div>
        <div>
            <p>
                <strong>4. Accuracy of Information</strong>
            </p>
            <p>
                We attempt to ensure that information provided through the Services is complete, accurate and current.
                Except as prohibited by applicable New Jersey law, we make no representation as to the completeness,
                accuracy or currency of any information provided through the Services and in the Materials. IKEA shall
                not be responsible for any errors or omissions in the Materials.
            </p>
        </div>
        <div>
            <p>
                <strong>5. Proprietary Rights</strong>
            </p>
            <p>
                You may choose to submit product reviews, feedback, and suggestions through the Services (“User
                Content”). IKEA does not claim ownership of any User Content that you provide to IKEA (including
                feedback and suggestions) or post, upload, input, or submit to the Service. Unless otherwise specified,
                you retain copyright and any other rights you already hold over User Content that you create and submit,
                post, or display on or through the Services. However, by submitting, posting, or displaying User
                Content, you give IKEA, its sub-licensees, and successors and assigns a perpetual, irrevocable,
                worldwide, royalty-free, and non-exclusive license to reproduce, adapt, modify, translate, publish,
                publicly perform, publicly display, distribute, reproduce, edit, reformat, and create derivative works
                from any User Content that you submit, post, or display on or through the Services. You acknowledge and
                agree that this license includes a right for IKEA to make such User Content available to other
                companies, organizations, or individuals with whom IKEA has relationships, and to use such User Content
                in connection with the provision of those services.{' '}
            </p>
        </div>
        <div>
            <p>
                <strong>6. Links</strong>
            </p>
            <p>
                The Services or Materials may allow connectivity (e.g., via links or references) to websites, platforms,
                and applications maintained and controlled by third parties (“Third Party Sites”) over whom IKEA has no
                control. Those Third Party Sites may collect and use data from you such as content or personal
                information. Any content or personal information you provide when using those Third Party Sites is
                subject to the terms and conditions and privacy policies of those Third Party Sites. Inclusion of any
                link to Third Party Sites within the Services or Materials does not imply an endorsement or
                recommendation of any material, substance, information, practice, or the owner or proprietor of such
                Third Party Sites by IKEA. IKEA makes no representations or warranties of any kind as to the accuracy,
                currency, or completeness of any information contained in such Third Party Sites and shall have no
                liability for any damages or injuries of any kind arising from the use of such Third Party Sites or any
                content or information contained in such Third Party Sites. You should refer to the terms and policies
                any Third Party Sites you use to determine your rights.
            </p>
        </div>
        <div>
            <p>
                <strong>7. Privacy</strong>
            </p>
            <p>
                IKEA takes the privacy of its customers very seriously. Your use of our Services is subject to our{' '}
                <Link to="/privacypolicy">Privacy Policy</Link>. Please read the Privacy Policy for information on how
                your personal information and other information about you will be handled. By accepting these Terms and
                Conditions you are also accepting the terms of the Privacy Policy, which are incorporated herein by
                reference for all applicable purposes. If you do not agree to these Terms and Conditions, please do not
                use the Services.
            </p>
        </div>
        <div>
            <p>
                <strong>8. Limitation of Liability</strong>
            </p>
            <p>
                WITHIN THE LIMITS ALLOWED BY APPLICABLE LAWS, YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT IKEA SHALL NOT BE
                LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING BUT
                NOT LIMITED TO, DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES (EVEN IF
                IKEA HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), RESULTING FROM: (a) THE USE OR THE INABILITY
                TO USE THE SERVICES; (b) ANY ACTION YOU TAKE BASED ON THE INFORMATION YOU RECEIVE IN, THROUGH, OR FROM
                THE SERVICES, (c) YOUR FAILURE TO KEEP YOUR PASSWORD OR ACCOUNT DETAILS SECURE AND CONFIDENTIAL, (d) THE
                COST OF PROCUREMENT OF SUBSTITUTE GOODS AND SERVICES RESULTING FROM ANY GOODS, DATA, INFORMATION, OR
                SERVICES PURCHASED OR OBTAINED OR MESSAGES RECEIVED OR TRANSACTIONS ENTERED INTO THROUGH OR FROM THE
                SERVICES; (e) UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA; (f) THE IMPROPER
                AUTHORIZATION FOR THE SERVICES BY SOMEONE CLAIMING SUCH AUTHORITY; or (g) STATEMENTS OR CONDUCT OF ANY
                THIRD PARTY ON THE SERVICES.
            </p>
        </div>
        <div>
            <p>
                <strong>9. Disclaimer of Warranties and Release</strong>
            </p>
            <p>
                YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT: (1) YOUR USE OF THE SERVICES ARE AT YOUR SOLE RISK. THE
                SERVICES ARE PROVIDED ON AN &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; BASIS. TO THE FULLEST EXTENT
                ALLOWED BY LAW, IKEA EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED,
                INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                PURPOSE, AND NON-INFRINGEMENT. (2) IKEA MAKES NO WARRANTY THAT (a) THE SERVICES WILL MEET YOUR
                REQUIREMENTS; (b) THE SERVICES WILL BE UNINTERRUPTED, TIMELY, UNFAILINGLY SECURE, OR ERROR-FREE; (c) THE
                RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICES WILL BE ACCURATE OR RELIABLE; (d) THE QUALITY
                OF ANY PRODUCTS, SERVICES, INFORMATION, OR OTHER MATERIAL PURCHASED OR OBTAINED BY YOU THROUGH THE
                SERVICES WILL MEET YOUR EXPECTATIONS AND (e) ANY ERRORS IN THE SOFTWARE WILL BE CORRECTED. (3) ANY
                MATERIAL DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE SERVICES IS DONE AT YOUR OWN DISCRETION
                AND RISK AND THAT YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR LOSS OF DATA
                THAT RESULTS FROM THE DOWNLOAD OF ANY SUCH MATERIAL. (4) NO ADVICE OR INFORMATION, WHETHER ORAL OR
                WRITTEN, OBTAINED BY YOU FROM IKEA OR THROUGH OR FROM THE SERVICES SHALL CREATE ANY WARRANTY NOT
                EXPRESSLY STATED IN THE TERMS. (5) YOU SHOULD ALWAYS USE CAUTION WHEN GIVING OUT ANY PERSONALLY
                IDENTIFYING INFORMATION ABOUT YOURSELF OR THOSE FOR WHOM YOU HAVE LEGAL AUTHORITY. IKEA DOES NOT CONTROL
                OR ENDORSE ANY ACTIONS RESULTING FROM YOUR PARTICIPATION IN THE SERVICES AND, THEREFORE, IKEA
                SPECIFICALLY DISCLAIMS ANY LIABILITY WITH REGARD TO ANY ACTIONS RESULTING FROM YOUR PARTICIPATION IN OR
                USE OF THE SERVICES.
            </p>
        </div>
        <div>
            <p>
                <strong>10. Release</strong>
            </p>
            <p>
                In the event that you have a dispute with one or more other users of the Services, you release IKEA (and
                its officers, directors, agents, subsidiaries, joint ventures and employees) from claims, demands and
                damages (actual and consequential) of every kind and nature, known and unknown, suspected and
                unsuspected, disclosed and undisclosed, arising out of or in any way connected with such disputes.
            </p>
        </div>
        <div>
            <p>
                <strong>11. Indemnification</strong>
            </p>
            <p>
                You agree to indemnify, defend and hold IKEA, its officers, directors, shareholders, employees and
                agents from and against all demands, liabilities, judgments, fines, interest, penalties, damages,
                losses, costs, claims or expenses (including, without limitation, attorneys’ fees and fees of other
                professional advisers) resulting from (i) your online conduct and use of the Services and Materials;
                (ii) your violation, breach or alleged breach of these Terms and Conditions; (iii) your failure to
                comply with any applicable laws or regulations; (iv) your negligence, willful misconduct, or violations
                of the intellectual property or other rights of any person, including without limitation, copyright and
                trademark infringement, obscene or indecent postings, and online defamation; or (v) any of your dealings
                or transactions with other persons resulting from use of the Services. You will be required to
                completely and fully indemnify IKEA for its losses.
            </p>
        </div>
        <div>
            <p>
                <strong>12. Legal Notice to New Jersey Residents</strong>
            </p>
            <p>
                No provision in these Terms and Conditions shall apply to any consumer in New Jersey if the provision
                limits redress for/under: (i) IKEA’s tortious actions (e.g., negligence, failure to exercise a basic
                standard of care, failure to avoid creating an unreasonable risk of harm); (ii) the New Jersey Products
                Liability Act, N.J.S.A. 2A:58C-1, et seq. (i.e., the statutorily imposed duty to refrain from
                manufacturing and selling dangerous products, with the possibility of punitive damages for violations
                thereof); (iii) the New Jersey Punitive Damages Act, N.J.S.A. 2A:15-5.9, et seq. (i.e., the statutory
                right to pursue punitive damages in the event of harm caused by actual malice, wanton and willful
                disregard, reckless indifference); (iv) the New Jersey Uniform Commercial Code (i.e., a comprehensive
                statutory regime governing the rights and duties of buyers and sellers with respect to contracts for the
                sale of goods, with the possibility of damages for economic and property harm); and (v) IKEA’s failure
                to reasonably protect against harm arising from certain criminal acts of third parties (e.g., computer
                hacking and identity theft, as regulated by the Federal Trade Commission and the Federal Communications
                Commission, and as governed by the New Jersey Identity Theft Protection Act, N.J.S.A.56:8-161, et seq.,
                and the New Jersey Consumer Fraud Act, N.J.S.A. 56:8-3, et seq.). With respect to these Terms and
                Conditions, the provision concerning the exclusion or limitation of certain damages is not applicable in
                New Jersey with respect to statutory damages, punitive damages, loss of data, and loss of or damage to
                property.{' '}
            </p>
        </div>
        <div>
            <p>
                <strong>13. Jurisdiction and General Terms</strong>
            </p>
            <p>
                The Services are intended for use in and by citizens and domiciliaries of the United States of America
                only. The Materials may contain information about products which may not be available in other countries
                or may be available under different trademarks in different countries, subject to different indications
                or restrictions of use. The Terms and Conditions shall be governed by and construed in accordance with
                the laws of the State of Pennsylvania, in the United States of America, regardless of where the user is
                based. You agree that any action at law or in equity arising out of or relating to these Terms and
                Conditions shall be filed only in the state or federal courts located in Montgomery County,
                Pennsylvania, U.S.A., and you hereby consent and submit to the personal jurisdiction of such courts for
                the purposes of litigating any such action.
            </p>
            <p>
                If any provision of these Terms and Conditions shall be unlawful, void, or for any reason unenforceable,
                then that provision shall be deemed severable from these Terms and Conditions and shall not affect the
                validity and enforceability of any remaining provisions.
            </p>
            <p>
                You or we may suspend or terminate your accounts or your use of the Services at any time, for any reason
                or for no reason. Unless otherwise stated, any other rules, restrictions, guidelines and terms and
                conditions that may be posted or made available in connection with a particular feature on the Services
                are incorporated by this reference into these Terms and Conditions.
            </p>
            <p>
                Your use of the Services is independent of IKEA and not as an employee, agent, partner, or
                joint-venturer with IKEA for any purpose.
            </p>
            <p>
                No waiver by either party of any breach or default hereunder shall be deemed to be a waiver of any
                preceding or subsequent breach or default.
            </p>
        </div>
        <div>
            <p>
                <strong>14. Changes to the Terms and Conditions</strong>
            </p>
            <p>
                IKEA may make changes to the Terms and Conditions from time to time. When these changes are made, IKEA
                will make a new copy of the Terms and Conditions available on its website and any new additional terms
                will be made available to you from within, or through, the affected Services.
            </p>
            <p>
                {' '}
                You acknowledge and agree that if you use the Services after the date on which the Terms and Conditions
                have changed, IKEA will treat your use as acceptance of the updated Terms and Conditions.
            </p>
        </div>
        <div>
            <p>
                <strong>15. Entire Agreement</strong>
            </p>
            <p>
                The Terms and Conditions and the other agreements referred to herein constitute the entire agreement
                between you and IKEA and supersedes any prior understandings or agreements (written or oral). If you do
                not understand any of the foregoing terms and conditions or if you have any questions or comments, we
                invite you to contact us at 1-888-888-4532, or infosec.dataprivacy.us@ikea.com.
            </p>
            <p>
                All design, graphics, text selections, arrangements, and software are Copyright© 2019 Inter IKEA Systems
                B.V. 1999-2019
            </p>
        </div>
    </>
)
